import { createSlice } from '@reduxjs/toolkit';
import { State } from './types';
import {
    getNotificationsThunk,
    seenNotificationThunk,
} from './thunks';

const initialState: State = {
    lastModify: null,
    notifications: [],
    fetchingNotifications: false,
};

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationsThunk.pending, (state) => {
                state.fetchingNotifications = true;
            })
            .addCase(getNotificationsThunk.fulfilled, (state, action) => {
                state.fetchingNotifications = false;
                state.lastModify = action.payload?.lastModify ?? null;
                state.notifications = action.payload?.notify ?? [];
            })
            .addCase(getNotificationsThunk.rejected, (state) => {
                state.fetchingNotifications = false;
            })
            // Flipped right away so the menu does not wait for the request to come back.
            .addCase(seenNotificationThunk.pending, (state, action) => {
                const notification = state.notifications.find(({ id }) => id === action.meta.arg);
                if (notification) notification.seen = true;
            })
            .addCase(seenNotificationThunk.rejected, (state, action) => {
                const notification = state.notifications.find(({ id }) => id === action.meta.arg);
                if (notification) notification.seen = false;
            })
    }
});
